module.exports = __webpack_public_path__ + "img/kachel-ALLERGIEN_LRHAUTPFLEGEPRODUKTEALLGEMEIN.76b5c335.png";